module.exports = __webpack_public_path__ + "img/01@2x.9846e246.png";